import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { ElMessage } from 'element-plus';
import common from '@/utils/common'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/store/modules/user'
import Cookies from 'js-cookie'
// 设置 withCredentials 为 true
// axios.defaults.withCredentials = true;

// 区分美吉、桑格
const {
  VITE_APP_MJ_KF_ORIGIN,
  VITE_APP_SG_KF_ORIGIN,
} = import.meta.env

let kfOrigin = ''

if (common.getWebName() === 'mj' || common.getWebName() === 'local') {
  kfOrigin = VITE_APP_MJ_KF_ORIGIN
} else if (common.getWebName() === 'sg') {
  kfOrigin = VITE_APP_SG_KF_ORIGIN
}


let axiosInstance = axios.create({
  // baseURL: '//svc.dngs.com/',
  baseURL: '',
  timeout: 60000, // 超时时间1分钟
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded',
  }
});

let isErrorShown = false

class Http {
  constructor() {
    this.httpInterceptorsRequest()
    this.httpInterceptorsResponse()
  }

  private static axiosInstance = axiosInstance;


  // 请求拦截器
  private httpInterceptorsRequest() {
    // @ts-ignore
    Http.axiosInstance.interceptors.request.use(async (config: AxiosRequestConfig) => {

      if (config['url'].indexOf('report/download') !== -1 || config['url'].indexOf('bacteria/download') !== -1) { // 下载流文件
        config.responseType = 'blob'
      }
      let from = ''
      let requestType = ''
      if (config.method === 'post' && config.data) {  // post
        from  = config.data.from
        requestType  = config.data.requestType
      } else if (config.method === 'get' && config.params) { // get
        from = config.params.from
        requestType = config.params.requestType
      }
      if (config.headers) {
        if (from === 'www.mj.com' || from === 'www.major.com' || from === 'www.majorbio.com'  || from === 'www.sg.com' || from === 'www.sanger.com' || from === 'www.i-sanger.com') {  // 科服网老接口
          config.baseURL = import.meta.env.VITE_APP_KF_BASE_URL
          if (config.method === 'post') {  // post
            if (config.data && config.data.formParams) { // formaData格式
              config.data = config.data.formParams
              delete config.data.formParams
            } else { 
              delete config.data.from
            } 
          } else if (config.method === 'get') { // get
            delete config.params.from
          }
        return config

          // 需要在浏览器中设置（在没有接口请求的页面设置MJUID、sso，记得设置Domain、expires）或者需要后端支持设置cookie：res.setHeader('Access-Control-Allow-Credentials', 'true');
        } else if (from === 'apix.mj.com' || from === 'apix.major.com' || from === 'apix.majorbio.com' || from === 'apix.sg.com' || from === 'apix.sanger.com' || from === 'apix.i-sanger.com' ) {  // 云平台老接口
          config.baseURL = import.meta.env.VITE_APP_CLOUD_BASE_URL
          if (common.getWebName() === 'mj') {
            config.baseURL = import.meta.env.VITE_APP_MJ_CLOUD_BASE_URL
          } else if (common.getWebName() === 'sg') {
            config.baseURL = import.meta.env.VITE_APP_SG_CLOUD_BASE_URL
          } else  if (common.getWebName() === 'local') {
            config.baseURL = import.meta.env.VITE_APP_MJ_CLOUD_BASE_URL
          } 
          
          if (config.method === 'post') {  // post
            if (config.data && config.data.formParams) { // formaData格式
              config.data = config.data.formParams
              delete config.data.formParams
            } else { 
              delete config.data.from
            } 
          } else if (config.method === 'get') { // get
            delete config.params.from
          }
          // token来自cloud.ypt.com，其实就是sso
          let sso = Cookies.get('sso')
          config.headers['Authorization'] = sso
        return config

          // 需要在浏览器中设置（在没有接口请求的页面设置MJUID、sso，记得设置Domain、expires）或者需要后端支持设置cookie：res.setHeader('Access-Control-Allow-Credentials', 'true');
        } else if (from === 'analysis.mj.com' || from === 'analysis.major.com' || from === 'analysis.majorbio.com' || from === 'analysis.sg.com' || from === 'analysis.sanger.com' || from === 'analysis.i-sanger.com' ) {  // 云分析老接口
          config.baseURL = import.meta.env.VITE_APP_ANALYSIS_BASE_URL
          if (config.method === 'post') {  // post
            if (config.data && config.data.formParams) { // formaData格式
              config.data = config.data.formParams
              delete config.data.formParams
            } else { 
              delete config.data.from
            } 
          } else if (config.method === 'get') { // get
            delete config.params.from
          }
          // token来自cloud.ypt.com，其实就是sso
          let sso = Cookies.get('sso')
          config.headers['Authorization'] = sso
        return config

          // 需要在浏览器中设置（在没有接口请求的页面设置MJUID、sso，记得设置Domain、expires）或者需要后端支持设置cookie：res.setHeader('Access-Control-Allow-Credentials', 'true');
        }else { // 新接口
          // token来自智能生产系统
          // pinia使用
          const userStore = useUserStore() 
          const { vipToken } = storeToRefs(userStore)
          
          let token = vipToken.value || common.getCache('vip-token')
          if (token || (!token && config.url === 'vip/login')) {
            if (requestType === 'erp_api') {
              config.baseURL = import.meta.env.VITE_APP_ERP_BASE_URL
              if (config.method === 'post') {  // post
                if (config.data && config.data.formParams) { // formaData格式
                  config.data = config.data.formParams
                  delete config.data.requestType
                } else {
                  delete config.data.from
                  delete config.data.requestType
                }
              } else if (config.method === 'get') { // get
                delete config.params.requestType
              }
            } else {
              config.baseURL = import.meta.env.VITE_APP_BASE_URL
            }
            // 调用新Vip系统的接口时，需要带上Authorization头信息
            config.headers['Authorization'] = token
            // 调用数据生产交付系统的接口时，需要带上Jwt头信息
            config.headers['Jwt'] = token
            // 调用支付接口时，需要带上Cookie头信息
            if (config.url?.indexOf('sample/disposal/pay') !== -1) {
              console.log(1111111111, config.url)
              config.headers['withCredentials'] = true
              // config.headers['access-control-allow-origin'] = window.location.origin
              // config.headers['access-control-allow-credentials'] = true
            }
            return config
          } else { // 不需要传token或者sso的接口，也就是没有权限卡控的接口请求（目前是接口version/last）
            console.log(333333, config)
            return config
          }
        }
      }

    }, err => {
      return Promise.reject(err)
    })
  }

  // 响应拦截器
  private httpInterceptorsResponse() {
    Http.axiosInstance.interceptors.response.use((response: AxiosResponse) => {
      if (response && response.request['responseType'].indexOf('blob') !== -1) { // 下载流文件
        return response
     } 
      if (response && response.status === 200) { 
        switch (response.data && response.data.code) { 
          case 310403:
            ElMessage({
              message: '您没有操作权限',
              type: 'error',
              showClose: true,
              duration: 6000
            });
            setTimeout(() => {
              window.location.href = `/403`
            }, 3000)
            break;
        }
      }

      return response
    }, err => {
      console.log('响应拦截器：', err)
      // 响应错误友好提示
      if (err.response) {
        const { data,status } = err.response
        switch (err.response && err.response.status) {
          case 404:
            ElMessage({
              message:status + '：'+data?.message,
              type: 'error',
              showClose: true,
              duration:6000
            });
            break;
          case 400:
            ElMessage({
              message:status + '：'+data?.message,
              type: 'error',
              showClose: true,
              duration:6000
            });
            break;
          case 401:
              // ElMessage({
              //   message: '您已登录失效，请重新登录2',
              //   type: 'error',
              //   showClose: true,
              //   duration:1500
              // });
            const userStore = useUserStore() 
            // setTimeout(() => { 
                // 退出登录清空一些缓存
                common.removeCache('vip-token')
                // common.removeCache('token')
                userStore.clearVipToken()
                common.removeCache('user')
                localStorage.removeItem('extraContact')
                Cookies.remove('contractReadVisible')
                Cookies.remove('panMajorbioVisible')
                Cookies.remove('sso')
              
                window.location.href = `${kfOrigin}/web/login/passport/logout`
              // },1500)
            break;
          case 403:
              ElMessage({
                message: '您没有操作权限',
                type: 'error',
                showClose: true,
                duration:6000
              });
              setTimeout(() => {
                window.location.href = `/403`
              }, 2000)
              break;
          case 500:
            if (!isErrorShown) {
                 ElMessage({
                  message: '系统繁忙，请稍后尝试哦~',
                  type: 'error',
                  showClose: true,
                  duration:6000
                });
              // ElMessage({
              //   message: '系统升级中，维护时间：2025年7月4日20:00 - 2025年7月5日18:00（共22小时）',
              //   type: 'warning',
              //   showClose: true,
              //   duration:6000
              // });
              isErrorShown = true
              // 3秒后重置状态，允许再次显示错误
              setTimeout(() => {
                isErrorShown = false
              }, 3000)
            }
              break;
          case 502:
            ElMessage({
              message: '系统升级，请稍后尝试~',
              type: 'error',
              showClose: true,
              duration:6000
            });
            break;
          case 504:
            ElMessage({
              message: '请求超时，请稍后尝试~',
              type: 'error',
              showClose: true,
              duration:6000

            });
            break;
          default:
            ElMessage({
              message: '连接服务器失败，请检查网络！',
              type: 'error',
              showClose: true,
              duration:6000

            });
            break;
        }
      } else {
        if (err.message === 'Network Error') {
          if (err.config.url.indexOf('front-error-monitor') === -1) {
            ElMessage('网络连接错误')
          } else {  // 避免监控系统的相关接口停用导致的报错
            return new Promise(() => { });
          }
        } else { 
          ElMessage({
            message: '请求超时，请确保网络环境良好~',
            type: 'error',
          });
        }
      
      }
      
      return Promise.reject(err);
    })
  }


  /** get 请求
  * @param  {接口地址} url
  * @param  {请求参数} params
  * @param  {参数} config
  */
  public httpRequestGet<T>(url: string, params: AxiosRequestConfig): Promise<T> {
      return Http.axiosInstance.get(url, { params }).then(res => res.data).catch()
  }

  /** post 请求
    * @param  {接口地址} url
    * @param  {请求参数} data
    * @param  {参数} config
    */
  public httpRequestPost<T>(url: string, params: AxiosRequestConfig): Promise<T> {
    return Http.axiosInstance.post(url, params).then(res => res.data).catch()
  }

  /** 下载流文件get
    * @param  {接口地址} url
    * @param  {请求参数} data
    * @param  {参数} config
    */
  public httpRequestGetBlob<T>(url: string, params: AxiosRequestConfig): Promise<T> {
    return Http.axiosInstance.get(url, { params }).then(res => res).catch()
  }
}

export const http = new Http()

